import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText, Typography } from "@mui/material";

type Props = {
  open: boolean;
  // Fields applyQuoteDraft couldn't restore from an old/changed draft shape - informational.
  warnings: string[];
  // How many section/line start dates staleStartDates found in the past - actionable.
  staleDateCount: number;
  onUpdateDates: () => void;
  onLeaveDates: () => void;
};

// Shown once, right after a draft is restored (see CreateQuotePage / QuoteDetailPage) - covers the
// two things a restore can produce: fields that couldn't be brought back from an older/changed
// draft shape (applyQuoteDraft), and start dates that have since passed (staleStartDates). Only
// rendered with `open` when there's actually something to report.
const DraftRestoredDialog = ({ open, warnings, staleDateCount, onUpdateDates, onLeaveDates }: Props) => <Dialog
  open={open} onClose={onLeaveDates} maxWidth="sm" fullWidth aria-labelledby="draft-restored-title">
  <DialogTitle id="draft-restored-title">Draft Restored</DialogTitle>
  <DialogContent dividers>
    {warnings.length > 0 && <Alert severity="warning" sx={{ mb: staleDateCount > 0 ? 2 : 0 }}>
      <Typography sx={{ mb: 1 }}>Some fields in this draft could not be restored:</Typography>
      <List dense disablePadding>
        {warnings.map((warning, index) => <ListItem key={index} disableGutters><ListItemText primary={warning} /></ListItem>)}
      </List>
    </Alert>}
    {staleDateCount > 0 && <Typography>
      {staleDateCount} start date{staleDateCount === 1 ? "" : "s"} in this restored quote {staleDateCount === 1 ? "has" : "have"} already passed.
      Update {staleDateCount === 1 ? "it" : "them"} to today?
    </Typography>}
  </DialogContent>
  <DialogActions>
    {staleDateCount > 0
      ? <>
        <Button color="inherit" onClick={onLeaveDates}>Leave As-Is</Button>
        <Button variant="contained" onClick={onUpdateDates}>Update to Today</Button>
      </>
      : <Button variant="contained" onClick={onLeaveDates}>OK</Button>}
  </DialogActions>
</Dialog>;

export default DraftRestoredDialog;
